import { createReducer } from 'typesafe-actions';
import { AuthState } from './interface'; //상태ts타입 가져오기
import { AuthAction } from './types'; //액션ts타입 가져오기
import { saveLastLoginMethod } from '../../util/lastLoginMethod';
import {
  LOGIN_SUCCESS,
  REGISTER_SUCCESS,
  FIND_ACCOUNTID,
  LOGOUT,
  ADMIN_ACCESS,
  REGISTER_USERNAME,
  LOGIN_RETURN_URL,
  RESET_PASSWORD,
  GET_USER_INFO,
  DAY_CHECK,
} from './actions'; //액션가져오기

const initialState: AuthState = {
  login: false,
  logout: false,
  register: false,
  isAdmin: false,
  permission: {
    name: null,
    useSpecificPermission: true,
    apiPermissions: [],
    pagePermissions: [],
  },
  loginReturnUrl: null,
  findAccountId: null,
  resetHash: null,
  expireTime: null,
  name: '',
  accountId: '',
  accountType: '',
  point: 0,
  dayCheck: 0,
};

// 리듀서 만들기
const auth = createReducer<AuthState, AuthAction>(initialState, {
  [LOGIN_SUCCESS]: (state, { payload: token }) => {
    localStorage.setItem('token', token);
    saveLastLoginMethod('NORMAL');

    return {
      ...state,
      login: true,
      logout: false,
    };
  },
  [REGISTER_USERNAME]: (state, { payload: name }) => {
    return {
      ...state,
      name: name,
    };
  },
  [FIND_ACCOUNTID]: (state, { payload: accountId }) => {
    return {
      ...state,
      findAccountId: accountId,
    };
  },
  [RESET_PASSWORD]: (state, { payload }) => {
    return {
      ...state,
      resetHash: payload.resetHash,
      expireTime: payload.expireTime,
    };
  },
  [REGISTER_SUCCESS]: (state, { payload: token }) => {
    localStorage.setItem('token', token);
    saveLastLoginMethod('NORMAL');

    return {
      ...state,
      register: true,
      login: true,
      logout: false,
    };
  },
  [LOGOUT]: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('cartIds');
    localStorage.removeItem('loginReturnUrl');
    //lastLoginMethod는 의도적으로 남긴다.
    //로그아웃 직후 다시 로그인할 때가 '최근 로그인' 표시가 가장 필요한 순간이다.

    return {
      ...initialState,
      logout: true,
    };
  },
  [ADMIN_ACCESS]: (
    state,
    {
      payload: {
        accountId,
        isAdmin,
        name,
        useSpecificPermission,
        apiPermissions,
        pagePermissions,
      },
    },
  ) => {
    return {
      ...state,
      isAdmin,
      accountId,
      permission: {
        name,
        useSpecificPermission,
        apiPermissions,
        pagePermissions,
      },
    };
  },
  [LOGIN_RETURN_URL]: (state, { payload: url }) => {
    localStorage.setItem('loginReturnUrl', url);

    return {
      ...state,
      loginReturnUrl: url,
    };
  },
  [GET_USER_INFO]: (state, { payload }) => {
    return {
      ...state,
      name: payload.name,
      accountId: payload.accountId,
      point: payload.point,
      accountType: payload.accountType,
    };
  },
  [DAY_CHECK]: (state, { payload }) => {
    return {
      ...state,
      dayCheck: payload,
    };
  },
});

export default auth;
